export enum NotificationObjectKind {
  UNKNOWN = 0,
  TYPE_ALARM_TRUE = 1,
  TYPE_ALARM_FALSE = 2,
  ALARM_TRUE = 3,
  ALARM_FALSE = 4,
  LOGIC_TRUE = 5,
  LOGIC_FALSE = 6,
  SCHEDULATION_TRUE = 7,
  PRECONDITIONING_TRUE = 8,
  PRECONDITIONING_END_TRUE = 9,
  SCENARIO_START = 10,
  SCENARIO_STOP = 11,
  SCENARIO_END = 12,
  ACCESS_CONTROL_ACCESS_GRANT = 13,
  ACCESS_CONTROL_ACCESS_DENIED = 14,
  LOGIC_USER_GRANTED = 15,
  LOGIC_USER_DENIED = 16,
  MASTERGATEWAY_CONNECTED = 17,
  MASTERGATEWAY_DISCONNECTED = 18,
  FINALGATEWAY_CONNECTED = 19,
  FINALGATEWAY_DISCONNECTED = 20,
  EMERGENCY_LAMP_GROUP = 21,
  ACCESS_CONTROL_ACCESS_GRANTED_GUEST = 22,
  ACCESS_CONTROL_ACCESS_DENIED_GUEST = 23,
  ACCESS_CONTROL_CARD_INSERT_ACCESS_GRANTED_GUEST = 24,
  ACCESS_CONTROL_CARD_REMOVED_ACCESS_GRANTED_GUEST = 25,
  ACCESS_CONTROL_CARD_INSERT_ACCESS_DENIED_GUEST = 26,
  ACCESS_CONTROL_ACCESS_GRANT_OTHER = 27,
  ACCESS_CONTROL_ACCESS_DENIED_OTHER = 28,
  ACCESS_CONTROL_CARD_INSERTED_ACCESS_GRANTED_OTHER = 29,
  ACCESS_CONTROL_CARD_REMOVED_ACCESS_GRANTED_OTHER = 30,
  ACCESS_CONTROL_CARD_INSERTED_ACCESS_DENIED_OTHER = 31,
  ACCESS_CONTROL_EXPIRING_CARD = 32
}

export enum BalloonKind {
  Single = 0,
  Cascade = 1
}

export enum BalloonIcon {
  None = 0,
  Info = 1,
  Warning = 2,
  Error = 3
}

export enum NotificationObjectKindGroup {
  Unknown = 0,
  Logic = 1,
  Scenario = 2,
  AccessControl = 3,
  LoginUser = 4,
  MasterGateway = 5,
  FinalGateway = 6
}

export enum NotificationObjectKind {
  Unknown = 0,
  TypeAlarmTrue = 1,
  TypeAlarmFalse = 2,
  AlarmTrue = 3,
  AlarmFalse = 4,
  LogicTrue = 5,
  LogicFalse = 6,
  SchedulationTrue = 7,
  PreconditioningTrue = 8,
  PreconditioningEndTrue = 9,
  ScenarioStart = 10,
  ScenarioStop = 11,
  ScenarioEnd = 12,
  AccessControlAccessGranted = 13,
  AccessControlAccessDenied = 14,
  LoginUserGranted = 15,
  LoginUserDenied = 16,
  MasterGatewayConnected = 17,
  MasterGatewayDisconnected = 18,
  FinalGatewayConnected = 19,
  FinalGatewayDisconnected = 20,
  EmergencyLampGroup = 21,
  AccessControlAccessGrantedGuest = 22,
  AccessControlAccessDeniedGuest = 23,
  AccessControlCardInsertedAccessGrantedGuest = 24,
  AccessControlCardRemovedAccessGrantedGuest = 25,
  AccessControlCardInsertedAccessDeniedGuest = 26,
  AccessControlAccessGrantedOther = 27,
  AccessControlAccessDeniedOther = 28,
  AccessControlCardInsertedAccessGrantedOther = 29,
  AccessControlCardRemovedAccessGrantedOther = 30,
  AccessControlCardInsertedAccessDeniedOther = 31,
  AccessControlExpiringCards = 32
}

export enum BIGLogicNotificationKind {
  OnChange = 0,
  Always = 1
}